import * as yup from 'yup';

export const AquaConfigurationSchema = yup.object({
  username: yup.string().required(),
  password: yup.string().required(),
  facilityId: yup.string().required(),
});

export interface IAquaConfiguration {
  username: string;
  password: string;
  facilityId: string;
}
